<script setup lang="ts">
import {
  getCollectionLink,
  getDuration,
  getThumbnailImage,
  isCollection,
} from "~/utils/common";
import type { PropType } from "vue";
import type { Collection } from "~/types";
import PgChip from "~/components/Common/PgChip.vue";
import { useCommonStore } from "~/stores/common/store";

const props = defineProps({
  item: {
    type: Object as PropType<Collection>,
    required: true,
  },
  showDuration: {
    type: Boolean,
    default: false,
  },
});

const { chipInfo } = useCollectionAiredData(props.item);

const commonStore = useCommonStore();
const { getVideoProgress } = commonStore;

const currentVideoProgress = computed(() => {
  return getVideoProgress(props.item.id);
});
</script>

<template>
  <NuxtLink
    :to="getCollectionLink({ type: item.type, slug: item.label })"
    class="block rounded-md border border-surface-border p-2 hover:bg-black lg:p-3"
  >
    <div class="relative w-full">
      <ProgressImgCard
        :progress-percent="currentVideoProgress?.progress_percent"
        :locked="!item.entitled && !isCollection(item.type)"
      >
        <NuxtImg
          :src="
            getThumbnailImage([item?.images || [], item?.pre_air_images || []])
          "
          alt="main thumbnail"
          class="aspect-video w-full"
          placeholder="/images/placeholder.png"
          loading="lazy"
        />
      </ProgressImgCard>
    </div>

    <div class="text-bold mt-2 flex flex-col gap-2 text-sm lg:text-base">
      <div v-if="chipInfo.label">
        <PgChip
          :icon="chipInfo.icon"
          :label="chipInfo.label"
          :bg="chipInfo.bg"
        />
      </div>

      <div>
        <div class="line-clamp-2 text-sm">
          {{ item.title }}
        </div>
        <div v-if="showDuration" class="mt-0.5 text-sm text-gray-400">
          ({{ getDuration(item.duration) }})
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped></style>
